
export const TRANSLATIONS = {
  fr: {
    // ... existantes ...
    b2b_sync_active: "Transmission temps-réel au professeur active",
    transformation_delta: "Évolution de capacité",
    improvement_detected: "Progression constatée : +{{val}}%",
    certified_proof: "Preuve Technique Certifiée",
    session_signature: "Signature unique de session",
    virtuoso_badge: "NIVEAU VIRTUOSE DÉBLOQUÉ",
    // ... 
    enter_studio: "Entrer dans le Studio",
    activate_api_key: "Activer Clé API Vision Lab",
    api_key_required: "Requis pour l'analyse anatomique",
    listen_to_coach: "ÉCOUTER MES CONSEILS",
    coach_tip_title: "Le Conseil du Coach",
    measured_facts: "Constats Mesurés",
    fact_rhythm: "Stabilité Rythmique",
    fact_harmony: "Justesse Harmonique",
    fact_articulation: "Clarté d'Attaque",
    fact_cleanliness: "Propreté du Jeu",
    performance_synthesis: "Synthèse de Performance",
    replay_take: "Rejouer la prise",
    compare_sync: "Comparer en détail",
    // Excellence Path
    excellence_title: "La Voie de l'Excellence",
    excellence_subtitle: "Le secret pour atteindre le 10/10",
    rhythm_10_title: "Précision Temporelle Absolue",
    rhythm_10_desc: "Synchronisation parfaite avec la pulsation Master.",
    harmony_10_title: "Pureté Harmonique",
    harmony_10_desc: "Chaque note de l'accord sonne clairement.",
    cleanliness_10_title: "Contrôle du Silence",
    cleanliness_10_desc: "Aucune résonance parasite entre les notes.",
    articulation_10_title: "Dynamique & Attaque",
    articulation_10_desc: "Maîtrise totale de l'impact et du volume.",
  },
  en: {
    b2b_sync_active: "Real-time transmission to teacher active",
    transformation_delta: "Capability evolution",
    improvement_detected: "Improvement detected: +{{val}}%",
    certified_proof: "Certified Technical Proof",
    session_signature: "Unique session signature",
    virtuoso_badge: "VIRTUOSO LEVEL UNLOCKED",
    enter_studio: "Enter the Studio",
    activate_api_key: "Activate Vision Lab API Key",
    api_key_required: "Required for anatomical analysis",
    listen_to_coach: "LISTEN TO MY ADVICE",
    coach_tip_title: "Coach's Tip",
    measured_facts: "Measured Facts",
    fact_rhythm: "Rhythmic Stability",
    fact_harmony: "Harmony Accuracy",
    fact_articulation: "Attack Clarity",
    fact_cleanliness: "Playing Cleanliness",
    performance_synthesis: "Performance Synthesis",
    replay_take: "Replay Take",
    compare_sync: "Compare in Detail",
    // Excellence Path
    excellence_title: "The Path to Excellence",
    excellence_subtitle: "The secret to reaching 10/10",
    rhythm_10_title: "Absolute Temporal Precision",
    rhythm_10_desc: "Perfect synchronization with the Master pulse.",
    harmony_10_title: "Harmonic Purity",
    harmony_10_desc: "Every note of the chord rings clearly.",
    cleanliness_10_title: "Silence Control",
    cleanliness_10_desc: "No parasitic resonance between notes.",
    articulation_10_title: "Dynamics & Attack",
    articulation_10_desc: "Total mastery of impact and volume.",
  }
};

export type Lang = 'en' | 'fr';
export type I18nKey = keyof typeof TRANSLATIONS.en;

export function t(key: I18nKey, lang: Lang, params?: Record<string, string | number>): string {
  let str = (TRANSLATIONS[lang] as any)[key] || (TRANSLATIONS['en'] as any)[key] || key;
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      str = str.replace(`{{${k}}}`, String(v));
    });
  }
  return str;
}